import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ThoratechSite from "@/pages/ThoratechSite";
import Privacy from "@/pages/Privacy";
import Careers from "@/pages/Careers";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import CookieBanner from "@/components/thoratech/CookieBanner";
import WhatsAppFAB from "@/components/thoratech/WhatsAppFAB";
import ScrollToHash from "@/components/thoratech/ScrollToHash";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<ThoratechSite />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
        <CookieBanner />
        <WhatsAppFAB />
      </BrowserRouter>
    </div>
  );
}

export default App;
